// NOTE - This wont push the children for a specific row
function flattenNestedArray<T>(row: any, subRowsField: string, idField: string): T[] {
  const filteredRowWithoutChildren = JSON.parse(JSON.stringify(row));
  delete filteredRowWithoutChildren[subRowsField];
  const flattened: T[] = [filteredRowWithoutChildren];
  if (row[subRowsField]) {
    row[subRowsField].map((subRow) => {
      const data: T[] = flattenNestedArray<T>(subRow, subRowsField, idField);
      flattened.push(...data);
    });
  }
  return flattened;
}

// helper functions
function updateAllNestedRows(rows, idField, subRowsField, updateFn) {
  return rows.map((row) => {
    if (row[subRowsField]) {
      row[subRowsField] = updateAllNestedRows(row[subRowsField], idField, subRowsField, updateFn);
    }
    return updateFn(row);
  });
}

function updateNestedRowsByCondition(rows, idField, subRowsField, conditionFn, updateFn) {
  return rows.map((row) => {
    if (row[subRowsField]) {
      row[subRowsField] = updateNestedRowsByCondition(
        row[subRowsField],
        idField,
        subRowsField,
        conditionFn,
        updateFn,
      );
    }
    if (conditionFn(row)) {
      return updateFn(row);
    } else {
      return row;
    }
  });
}

function updateRowById(rows, idField, subRowsField, targetId, updateFn) {
  return rows.map((row) => {
    // If this is the row we want to update
    if (row[idField] === targetId) {
      return updateFn(row);
    }

    // If this row has subRows, recursively search and update them
    if (row[subRowsField]) {
      return {
        ...row,
        [subRowsField]: updateRowById(row[subRowsField], idField, subRowsField, targetId, updateFn),
      };
    }

    // Otherwise return the row unchanged
    return row;
  });
}

function updateNestedRow(prevData, idField, subRowsField, targetId, updates) {
  return updateRowById(prevData, idField, subRowsField, targetId, (row) => ({
    ...row,
    ...updates,
  }));
}

function findRowById(rows, idField, subRowsField, targetId) {
  // Base case: if rows is not an array or empty
  if (!Array.isArray(rows) || rows.length === 0) {
    return null;
  }

  // Look for the row in the current level
  const foundRow = rows.find((row) => row[idField] === targetId);
  if (foundRow) {
    return foundRow;
  }

  // If not found, recursively search in subRows
  for (const row of rows) {
    if (row[subRowsField]) {
      const foundInSubRows = findRowById(row[subRowsField], idField, subRowsField, targetId);
      if (foundInSubRows) {
        return foundInSubRows;
      }
    }
  }

  // If not found anywhere
  return null;
}

function deleteNestedRow(
  rowId: string | number,
  idField: string,
  subRowsField: string,
  currentData: any[],
): any[] {
  return currentData.reduce<any[]>((acc, row) => {
    if (row[idField] === rowId) {
      return acc;
    }

    const newRow = { ...row };

    if (newRow[subRowsField]) {
      newRow[subRowsField] = deleteNestedRow(rowId, idField, subRowsField, newRow[subRowsField]);
    }

    if (newRow[subRowsField]?.length || newRow[idField] !== rowId) {
      acc.push(newRow);
    }

    return acc;
  }, []);
}

export {
  deleteNestedRow,
  findRowById,
  flattenNestedArray,
  updateAllNestedRows,
  updateNestedRow,
  updateNestedRowsByCondition,
};
